import { render, staticRenderFns } from "./ArchiveCard.vue?vue&type=template&id=f0823e36&"
import script from "./ArchiveCard.vue?vue&type=script&lang=js&"
export * from "./ArchiveCard.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports